// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ERROR_PLEASE_RELOAD = "Stala sa chyba, sk\u00fas pros\u00edm znova na\u010d\u00edta\u0165 str\u00e1nku.";
